import React from 'react';

import { ErrorSection } from 'components/ErrorSection';
import { CenteredLayout } from 'layouts/CenteredLayout';
import { setDocumentTitle } from 'utils/meta';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: Record<string, any>;
}; // error saved to redux by async code

export class ErrorPage extends React.PureComponent<Props> {
  componentDidMount() {
    setDocumentTitle(getText('Something Went Wrong'));
  }

  render() {
    return (
      <CenteredLayout>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/destructuring-assignment */}
        <ErrorSection error={this.props.error} />
      </CenteredLayout>
    );
  }
}
